export default {
  message: {
    accountSessionTitle: '登录状态已更新',
    loginSessionUnavailable: '未能建立有效登录状态，账号资料可能不完整或 Cookie 不可用，请重新登录。',
    accountSession_checking: '正在重新校验当前账号的参会权限。',
    accountSession_anonymous: '登录已失效，正在返回登录页。',
    sessionLoginSuccess: '登录成功',
    sessionLoginReturnHint: '登录状态已更新，请从会议邀请链接进入会议。',
    accountSession_denied: '当前账号未通过参会权限校验，已暂停原账号的会议操作。',
    accountSession_error: '暂时无法校验当前账号权限，请稍后重试。',
    accountSession_changed: '当前账号权限已校验，但无法确认与已连接的参会身份一致。请自行离会后重新进入，以使用新身份。',
    accountSessionConnection: '不会因登录变化自动退出会议；身份确认前暂停操作，现有会议连接暂时保留。',
    accountSessionRetry: '重新校验',
    accountSessionLogin: '重新登录',
    microphoneChanging: '处理中...',
    microphoneSwitchRestored: '切换麦克风失败，已恢复原麦克风。',
    microphoneRestoreFailed: '切换失败，原麦克风也未能恢复。请重新选择设备并开启麦克风。',
    microphoneSwitchPending: '设备切换请求尚未结束，已暂停麦克风，正在等待并恢复原设备。若长时间未恢复，请重新入会。',
    remoteAudioFailedTitle: '部分会议声音未能恢复',
    remoteAudioFailed: '已尝试重新连接音频，请点击“恢复声音”重试。如仍无声音，请检查网络或重新入会。',
    audioGestureTitle: '需要开启会议声音',
    audioGestureHint: '浏览器阻止了会议声音自动播放，请点击“开启声音”继续收听。',
    microphoneFailed: '麦克风操作失败，请检查设备和权限后重试。',
    screenStarting: '正在开启投屏...',
    screenStopping: '正在停止投屏...',
    screenShareFailed: '投屏未能完成，请检查共享选择和浏览器权限后重试。',
    joinMeeting: '加入会议',
    phonePlaceHolder: '请输入手机号',
    emailPlaceHolder: '请输入邮箱',
    within: '中国境内',
    overseas: '中国境外',
    codePlaceHolder: '请输入验证码',
    imageCodePlaceHolder: '请输入图形验证码',
    imageCodeAlt: '图形验证码',
    getCode: '获取验证码',
    getImageCode: '获取图形验证码',
    getting: '获取中...',
    getImageCodeFirst: '请先获取图形验证码',
    imageCodeFail: '获取图形验证码失败',
    getEmailCode: '发送验证码邮件',
    rightPhone: '请输入正确的手机号',
    rightEmail: '请输入正确的邮箱',
    join: '加入',
    codeSuccess: '验证码发送成功',
    codeFail: '发送失败，请稍后再试',
    wait: '等待主持人开始会议',
    time: '距离会议开始还有',
    introduce: '会议介绍',
    expert: '专家',
    expertPhone: '专家-电话',
    guest: '嘉宾',
    host: '主持人',
    audience: '观众',
    saySomething: '说点什么',
    handsUpSuccess: '举手成功，将想说的话通过对话框告诉主持人',
    logout: '请问你确认要退出登录嘛',
    leave: '确定要离开会议嘛',
    set: '设置',
    setMic: '设置麦克风',
    errorMic: '请先授权麦克风权限',
    errorCamera: '请先授权摄像头权限',
    loading: '正在入会，请稍后',
    end: '感谢您参加会议',
    meetingRescheduledEnd: '由于专家原因，会议需要改期，请谅解',
    textBD: '请联系您的BD',
    error1: '很抱歉，您访问的地址不存在',
    error2: '很抱歉，您的会议号有误',
    error3: '很抱歉，您没有会议权限',
    error4: '很抱歉，您参加的会议已经结束',
    error5: '很抱歉，您参加的会议室正在占用中，请联系管理员',
    error6: '很抱歉，系统暂不支持在微信浏览器中使用，请打开chrome/safari浏览器使用',
    wechatBrowserTitle: '请在默认浏览器中打开',
    copyingMeetingLink: '正在复制会议链接...',
    meetingLinkCopied: '会议链接已复制，请粘贴到默认浏览器中打开',
    meetingLinkCopyFallback: '无法自动复制，请长按或选中下方链接复制，再粘贴到默认浏览器中打开',
    meetingLinkMissingTitle: '请重新打开会议邀请链接',
    meetingLinkMissingHint: '当前地址未包含会议信息，请从微信聊天或邮件中找到原始会议邀请链接，并在默认浏览器中打开。',
    wechatBrowserHint: '点击右上角“···”，选择“在默认浏览器中打开”',
    weeklyActivityNotStarted: '本周周会已结束',
    audienceCount: '观众人数',
    notFound: '查无此账号，请联系BD预开账号',
    joining: '正在加入会议',
    loadingMeetingInfo: '正在加载会议信息',
    meetingTime: '会议时间',
    enterMeetingRoom: '进入会议室',
    meetingStatus: '会议状态',
    meetingStatusRegistering: '报名中',
    meetingStatusEnded: '已结束',
    meetingStatusPendingStart: '待开始',
    restartingMeeting: '正在重启会议...',
    restartMeetingConfirm: '确定重启会议吗？会议将恢复为待开始状态，您可以重新进入会议室。',
    restartMeetingSuccess: '会议已重启，正在刷新会议信息',
    restartMeetingFailed: '重启会议失败，请稍后重试',
    restartMeetingInfoMissing: '未获取到有效的会议编号，请刷新后重试',
    restartMeetingLoginRequired: '登录已失效，请重新登录后重启会议',
    meetingStatusInProgress: '会议中',
    meetingStatusRegistered: '已报名',
    meetingStatusRescheduled: '会议改期待定',
    meetingStatusUnknown: '未知状态',
    leaveMsg: '离开会议之前，请将主持人权限移交给会议助理',
    emptyLeaveMsg: '离开会议5分钟后主持人权限会被流转给观众，如果确认不再继续会议，建议直接结束会议。',
    shareScreen: '分享屏幕时如果要同步分享计算机声音请勾选下方同时分享系统音频！',
    shareScreen1: '分享成功，请确认观众是否能够听到音频！',
    changeVideo: '打开摄像头后所有观众都将看到您，请确认是否打开',
    loginElsewhere: '您的手机号在其他地方登录，请重新参加会议',
    welcome: '欢迎加入久谦Forum会议',
    recordingRequiredTitle: '云录制未启动',
    recordingStartFailed: '云录制启动失败，会议不能在未录制状态下继续。请检查网络后重新尝试。',
    recordingRequiredBeforeStart: '云录制尚未启动，暂时不能开始会议，系统正在重新尝试。',
    turnOnCamera: "开启摄像头",
    turnOffCamera: "关闭摄像头",
    startMeeting: "开始会议",
    endingMeeting: "正在结束会议...",
    endMeetingFailed: "结束会议失败，请检查网络后重试",
    reschedulingMeeting: "改期中...",
    rescheduleMeetingTitle: "确认会议改期",
    rescheduleMeetingConfirm: "确认会议需要改期吗？确定后当前会议将结束，客户会收到改期通知。",
    rescheduleMeetingSuccess: "会议已改期，客户将收到改期通知",
    rescheduleMeetingFailed: "会议改期失败，请稍后重试",
    rescheduleMeetingInfoMissing: "未获取到当前会议信息，请刷新后重试",
    coHost: "助理主持人",
    becomeRole: "您已成为{role}！",
    feedbackTitle: "活动反馈",
    expertScore: "定性评分",
    quantitativeScore: "定量评分",
    canLongTermCooperate: "是否可以长期合作",
    canLongTermCooperateYes: "可以",
    canLongTermCooperateNo: "不可以",
    isCreateTranscript: "是否生成纪要",
    createTranscriptYes: "创建",
    createTranscriptNo: "不创建",
    createTranscriptRequired: "请选择是否生成纪要",
    qualitativeScoreRequired: "请选择 1-4 星定性评分",
    quantitativeScoreRequired: "请选择 1-4 星定量评分",
    longTermCooperateRequired: "请选择是否可以长期合作",
    feedbackEvaluationRequired: "请填写对于该专家的评价",
    feedbackEvaluationLimit: "专家评价不能超过512字符",
    expertEvaluationPlaceholder: "请填写对于该专家的评价",
    feedbackSuccess: "反馈提交成功",
    feedbackFailed: "反馈提交失败，请稍后重试",
    feedbackLeaveWarning: "评分尚未提交，确定要离开当前页面吗？",
    activityQuestions: "活动提问",
    loadingQuestions: "正在加载客户提问...",
    refreshingQuestions: "刷新中...",
    noActivityQuestions: "暂无客户提问",
    questionLoadFailed: "提问加载失败，请点击刷新重试",
    questionImage: "提问图片",
    questionFile: "提问附件"
  },
  button: {
    copyMeetingLink: '复制会议链接',
    retryAudio: '恢复声音',
    enableAudio: '开启声音',
    stopScreen: '停止投屏',
    retry: '{count}s后重试',
    handsUp: '举手',
    leave: '离开',
    submit: '发送',
    feedbackSubmit: '提交',
    warning: '警告',
    confirm: '确定',
    cancel: '取消',
    micPhone: '选择麦克风',
    screen: '分享屏幕',
    mute: '静音',
    unmute: '解除静音',
    switchLang: 'English',
    malfunction: '无设备',
    checkout: '退出',
    moderator: '获取主持人权限',
    email_login: '邮箱登录',
    mobile_login: '手机号登录',
    tips: '提示',
    end: '结束',
    rescheduleMeeting: '会议改期',
    restartMeeting: '重启会议',
    refresh: '刷新',
    retryRecording: '重新尝试录制'
  },
  network: {
    type1: '网络正常',
    type2: '网络延迟',
    type3: '网络延迟严重',
    delay: '延迟'
  }
}
